// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__9u7xb","spin":"styles_spin__MfgT_"};